import React from 'react';

const PageContext = React.createContext({});

export const PageSettings = PageContext.Provider;

export default PageContext;
